import { Component, Inject, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA } from "@angular/material/bottom-sheet";
import { MatDialog } from "@angular/material/dialog";
import { AuthService } from "@core/auth.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
// import { ChangeImagePopupComponent } from './change-image-popup/change-image-popup.component';
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { Data } from "@angular/router";
import { AnimationOptions, LottieComponent } from "ngx-lottie";
import { BehaviorSubject } from "rxjs";
import { SocialService } from "src/app/services/social.service";
import { ChangeImagePopupComponent } from "./change-image-popup/change-image-popup.component";
import { MatTabGroup, MatTab, MatTabLabel } from "@angular/material/tabs";
import { NgClass, AsyncPipe } from "@angular/common";
import { FortuneLifestyleComponent } from "./fortune-lifestyle/fortune-lifestyle.component";
import { FortuneDiscoverComponent } from "./fortune-discover/fortune-discover.component";
import { FortuneMissionsComponent } from "./fortune-missions/fortune-missions/fortune-missions.component";

@Component({
    selector: "app-fortune-subtabs",
    templateUrl: "./fortune-subtabs.component.html",
    styleUrls: ["./fortune-subtabs.component.scss"],
    standalone: true,
    imports: [
        MatTabGroup,
        MatTab,
        MatTabLabel,
        NgClass,
        LottieComponent,
        FortuneLifestyleComponent,
        FortuneDiscoverComponent,
        FortuneMissionsComponent,
        AsyncPipe,
        TranslatePipe,
    ],
})
export class FortuneSubtabsComponent implements OnInit, OnChanges {
  selectedLanguage: string;
  userFortuneMapData$ = new BehaviorSubject(null);
  imageUrl: string;
  isAnimate: boolean;
  netWorth: string;
  options: AnimationOptions = {
    path: "../../../../assets/tap-animation.json",
  };
  @Input() currentTab: number;
  selectedTab: String;
  public userId: string;
  constructor(
    private authService: AuthService,
    public translate: TranslateService,
    private matDialog: MatDialog,
    private afs: AngularFirestore,
    private socialService: SocialService,

    @Inject(MAT_BOTTOM_SHEET_DATA) public data: Data
  ) {
    this.currentTab = data?.currentTab;
    this.selectedTab = data?.selectedTab;

    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l ? l : "en";
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );
  }
  async ngOnInit() {
    await this.authService
      ?.getUid("FortuneSubtabsComponent")
      ?.then((uid) => {
        this.userId = uid;
      })
      .catch((error) => {
        return error;
      });
    this.socialService.socialFortuneAlbums$.subscribe(
      (data: Data) => {
        if (data) {
          this.netWorth = this.getNetWorth(data?.data?.assets_value);
        }
      },
      (error) => {
        const zero = "0";
        this.netWorth = zero;
        return new Error(error);
      }
    );
    this.socialService
      ?.socialFortuneMapGlobalData()
      .then((d) => {
        if (d[4]?.collection == "fortuneMapUrl") {
          this.imageUrl = d[4].data.background_url;
        }
      })
      .catch((err) => {
        return err;
      });
    this.socialService?.socialFortuneMap$.subscribe((d) => {
      this.userFortuneMapData$.next(d);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes?.currentTab?.currentValue) {
      if (changes.currentTab.currentValue === 0) {
        this.currentTab = 0;
      } else if (changes.currentTab.currentValue === 1) {
        this.currentTab = 1;
      } else if (changes.currentTab.currentValue === 2) {
        this.currentTab = 2;
      } else if (changes.currentTab.currentValue === 3) {
        this.currentTab = 3;
      } else {
        this.currentTab = 0;
      }
    } else {
      this.currentTab = 0;
    }
  }
  changeImg(e: string, l: Data, property: string) {
    for (let key of Object.keys(l)) {
      if (key === property) {
        this.isAnimate = l[key]?.change_status;
        if (this.isAnimate == false) {
          this.socialService.setData(l[key].navigation_page);
        } else {
          let data = this.matDialog.open(ChangeImagePopupComponent, {
            panelClass: "change-img-popup",
            data: { data: e, 2: l },
          });
          data?.afterClosed().subscribe(
            (d) => {
              if (d) {
                const user = this.userId;
                const docRef = this.afs.doc(`users/${user}/gamification/fortune_map`);
                docRef.get().subscribe((doc) => {
                  if (doc?.exists) {
                    docRef
                      .update({
                        [`${d.collectionName}.image_url`]: d.image,
                        [`${d.collectionName}.change_status`]: false,
                      })
                      .then(() => {
                        docRef
                          .get()
                          .toPromise()
                          .then((doc) => {
                            const data = doc?.data();
                            this.userFortuneMapData$.next(data);
                          });
                      })
                      .catch((err) => {
                        return err;
                      });
                  } else {
                    return new Error("Document not found");
                  }
                });
              }
            },
            (err) => {
              return new Error(err);
            }
          );
        }
      }
    }
  }

  // This function is used to display the networth with abbreviations based on the amount
  NUMERIC_MAP = {
    BILLION: 1e9,
    MILLION: 1e6,
    THOUSAND: 1e3,
  };

  CURRENCY_ABBREVIATIONS = {
    [this.NUMERIC_MAP.BILLION]: "B",
    [this.NUMERIC_MAP.MILLION]: "M",
    [this.NUMERIC_MAP.THOUSAND]: "K",
  };

  getNetWorth(amount: number) {
    let value = amount;
    let abbreviation = "";

    for (const key in this.NUMERIC_MAP) {
      if (amount >= this.NUMERIC_MAP[key]) {
        value = amount / this.NUMERIC_MAP[key];
        abbreviation = this.CURRENCY_ABBREVIATIONS[this.NUMERIC_MAP[key]];
        break;
      }
    }
    return `${value.toFixed(Number.isInteger(value) ? 0 : 1)}${abbreviation}`;
  }
}
